import { jsx } from "react/jsx-runtime";
import WorkIcon from "@mui/icons-material/Work";
import { validateTidalLicense } from "../../base/index.js";
function Work(props) {
  return /* @__PURE__ */ jsx(
    WorkIcon,
    {
      "data-testid": "Work",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Work",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Work.tidalIconMeta = {
  categories: "fileActions",
  name: "Work"
};
validateTidalLicense();
export {
  Work
};
//# sourceMappingURL=Work.js.map
